import React from 'react';
import { LyricsConfigError } from 'app/components/Song/Lyrics/TextEditorErrorBoundary/types';
import { NotSupportedError } from 'app/components/Song/Lyrics/NotSupportedError';
import { ErrorBoundaryMessage } from 'app/components/ErrorBoundary/ErrorBoundaryMessage';

export class TextEditorErrorBoundary extends React.Component<
  unknown & { children?: React.ReactNode },
  { errorType: LyricsConfigError | null }
> {
  constructor(props) {
    super(props);
    this.state = { errorType: null };
  }

  static getDerivedStateFromError(error) {
    return { errorType: error?.message || null };
  }

  render() {
    const { children } = this.props;
    const { errorType } = this.state;

    if (errorType === LyricsConfigError.UNSUPPORTED_EXTENSION_FOUND) {
      return <NotSupportedError />;
    }

    if (errorType === LyricsConfigError.UNKNOWN) {
      return <ErrorBoundaryMessage />;
    }

    return children;
  }
}
